/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/da'

import iconSet from 'quasar/icon-set/mdi-v5'


import Vue from 'vue'

import Quasar from 'quasar/src/vue-plugin.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Cookies from 'quasar/src/plugins/Cookies.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import LoadingBar from 'quasar/src/plugins/LoadingBar.js';import Loading from 'quasar/src/plugins/Loading.js';


Vue.use(Quasar, { config: {"loadingBar":{"color":"info"}},lang: lang,iconSet: iconSet,components: {QSpinner,QSpinnerGears,QSpinnerIos,QSpinnerHourglass},plugins: {Notify,Dialog,Cookies,LocalStorage,LoadingBar,Loading} })
